import { AuthActionTypes, useStateContext, useStateDispatcher } from "state";
import { useQuery } from "@tanstack/react-query";
import { useClientContext } from "clients";
import { dtoToUser } from "models/user";

export const getUserQUeryKey = "getUser";

const useGetUser = () => {
  const dispatcher = useStateDispatcher();
  const clients = useClientContext();
  const state = useStateContext();

  return useQuery({
    queryFn: async () =>
      await clients.management
        .getOrganizationUser(state.tokens?.user_id || 0)
        .then(dtoToUser),
    onSuccess: (user) => dispatcher({ type: AuthActionTypes.SET_USER, user }),
    queryKey: [getUserQUeryKey, state.tokens?.user_id],
    enabled: !!state.tokens,
  });
};

export default useGetUser;
